// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { isPlatformIframe } from '../../platform/utils/platformDetailsUtils';

// Components
import BreadcrumbList from '../breadcrumbs/Components/BreadcrumbList';
import AccountUtil from '../header/workspaceToolsHeader/account/AccountUtil';
import NotificationsUtil from '../header/workspaceToolsHeader/notifications/NotificationsUtil';
import MobileGuestSettingsUtil from './MobileGuestSettingsUtil';

// Styles
import './AppHeaderMobile.scss';

const AppHeaderMobile = (props) => (
    <header className="AppHeader AppHeaderMobile">
        <div className="header-section header-tools">
            <div className="header-left">
                <BreadcrumbList {...props} isMobileView />
            </div>
            <div className="header-right">
                {!props.isGuest && !isPlatformIframe(props.platformDetails) && (
                    <NotificationsUtil
                        pageTitle={props.pageTitle}
                        currentUser={props.currentUser}
                        tooltipEnabled={!props.utilPopupOpened}
                        isMobileView
                    />
                )}
                {!props.isGuest && !isPlatformIframe(props.platformDetails) && (
                    <AccountUtil currentUser={props.currentUser} isGuest={props.isGuest} isMobileView />
                )}
                {props.isGuest && <MobileGuestSettingsUtil />}
            </div>
        </div>
    </header>
);

AppHeaderMobile.propTypes = {
    currentUser: PropTypes.object,
    currentBoardId: PropTypes.string.isRequired,
    isEditable: PropTypes.bool,
    isGuest: PropTypes.bool,
    getDocumentElementSizes: PropTypes.func,
    breadcrumbObj: PropTypes.object,
    utilPopupOpened: PropTypes.bool,
    utilTooltipOpened: PropTypes.bool,
    pageTitle: PropTypes.string,
    platformDetails: PropTypes.object.isRequired,
};

export default AppHeaderMobile;
